<template>

  <RiskTip :project-risk="projectRisk" />
</template>

<script>
import RiskTip from '@/views/public_0983cc/project/detail/public/RiskTip.vue'
export default {
  components: {
    RiskTip
  },
  props: {
    projectRisk: {
      type: String,
      default: '暂无提示'
    }
  }
}
</script>

      <style>

      </style>
